import { useFormContext } from "react-hook-form";
import QRCode from "react-qr-code";
import { useAuth, type SignInParams } from "~/presentation/core/contexts/AuthContext";
import { TextInput } from "~/components/Input";
import { FieldLabel, FormControl } from "~/components/FormControl";
import { Button } from "~/components/Button";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";

export interface TwoFactorAuthFormProps {
  onSignIn: (data: SignInParams) => Promise<void>;
}

export const TwoFactorAuthForm = () => {
  const { qrCodeUrl } = useAuth();

  const { control } = useFormContext<SignInParams>();

  return (
    <>
      <Flex direction="column" gap="5">
        {qrCodeUrl ? (
          <>
            <Flex justify="center">
              <QRCode size={256} value={qrCodeUrl} />
            </Flex>

            <FormControl name="securityKey" control={control} required>
              <FieldLabel>Código de segurança</FieldLabel>
              <TextInput id="login-secret-key" autoComplete="one-time-code" autoFocus />
            </FormControl>
          </>
        ) : qrCodeUrl === null ? (
          <FormControl name="securityKey" control={control} required>
            <FieldLabel>Código de segurança</FieldLabel>
            <TextInput
              data-cy="security-code-input"
              id="login-secret-key"
              autoComplete="one-time-code"
              autoFocus
            />
          </FormControl>
        ) : (
          <Text size="3" variant="dark" css={{ lineHeight: 1.4, textAlign: "center" }}>
            {qrCodeUrl
              ? "Para entrar, escaneie o QR code abaixo com o aplicativo Google Authenticator e informe o código de segurança gerado"
              : "Informe o código de segurança gerado pelo aplicativo Google Authenticator para entrar"}
          </Text>
        )}
      </Flex>

      <Button data-cy="confirm-code-button" type="submit" fullWidth>
        Confirmar código
      </Button>
    </>
  );
};
